import { searchCommonConfig } from './common'
import { theme as brandTheme } from '@/config/brands'

/**
 * Flipnovel 品牌搜索页面配置
 */
export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: brandTheme.bgTag,
    startReadingBg: brandTheme.primaryGradient || 'linear-gradient(90deg, #FF8A4C 0%, #FF5A36 100%)',
    isLight: false,
    cardPadding: '10px',
    cardBorder: '1px solid rgba(255, 255, 255, 0.06)',
    cardBg: 'rgba(255, 255, 255, 0.02)',
  },
}
